import React,{useState , useEffect} from "react";
import { Link } from "react-router-dom";
import {APP_URL,API_ENDPOINT,FOOTER_SITE , BACKEND_URL} from '../components/config/Common'
import {Links} from '../routes/PathLink'

import { LazyLoadImage,LazyLoadComponent } from 'react-lazy-load-image-component';
//import { FloatingWhatsApp } from 'react-floating-whatsapp'
import { useSiteSettings } from '../site-settings/site-settings';

import { nanoid } from 'nanoid';


const Footer = ({ishome,hidegroup,hidefooter}) => {
    const [access_token,setAccess_token] = useState(localStorage.getItem('access_token'));
    const [isLogin, setIsLogin] = useState(false)
    const [footergroup , setFootergroup] = useState([]);
    const [column1data , setColumn1data] = useState([]);
    const [column2data , setColumn2data] = useState([]);
    const [column3data , setColumn3data] = useState([]);
    const [paymenticons , setPaymenticons] = useState([]);
    const [followicons , setFollowicons] = useState([]);
    const [loadFooter , setSetLoadFooter] = useState(false);
   const { sitelogo } = useSiteSettings();
    useEffect(() => {
      
        get_footer_footergroupsec();
        get_footer_column1();
        get_footer_column2();
        get_footer_column3();
        getPaymentIcon();
        getfollowLinks();

        setTimeout(() => {
            setSetLoadFooter(true);
         }, 1000)
   },[])

    useEffect(() => {
        if(access_token){
            setIsLogin(true)
        }
    }, [access_token]);

    const getPaymentIcon=()=>{
       /* fetch(`${APP_URL}/img/paymenticons/paymenticons.json`
        ,{
          headers : { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
           }
        }
        )
          .then(function(response){
            
            return response.json();
          })
          .then(function(myJson) {
            setPaymenticons(myJson)
          });
          */
      }

    const getfollowLinks=()=>{
       /* fetch(`${APP_URL}/sociallinkFooterjson.json`
        ,{
          headers : { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
           }
        }
        )
          .then(function(response){
            
            return response.json();
          })
          .then(function(myJson) {
            setFollowicons(myJson)
          });
          */
      }

     const get_footer_footergroupsec = () =>{

        /* fetch(`${API_ENDPOINT}/get_categorylevel_list`,{
            method: 'GET',
            headers : {        
                'Content-Type': 'application/json',
                'Accept': 'application/json', 
            }
        }).then(function (response) {
                return response.json();
        }).then( (result)=> {
            
            if(result.status === 1){
               setFootergroup(result?.data);
            }
        })
            */

    }

    const get_footer_column1 = () =>{

        fetch(`${API_ENDPOINT}/get_footer_links?colum=column1`,{
            method: 'GET',
            headers : {        
                'Content-Type': 'application/json',
                'Accept': 'application/json', 
            }
        }).then(function (response) {
                return response.json();
        }).then( (result)=> {
           
            if(result.status === 1){
               setColumn1data(result?.data);
            }
        })
    }

    const get_footer_column2 = () =>{

        fetch(`${API_ENDPOINT}/get_footer_links?colum=column2`,{
            method: 'GET',
            headers : {        
                'Content-Type': 'application/json',
                'Accept': 'application/json', 
            }
        }).then(function (response) {
                return response.json();
        }).then( (result)=> {
            if(result.status === 1){
               setColumn2data(result?.data);
            }
        })
    }

const get_footer_column3 = () =>{

        fetch(`${API_ENDPOINT}/get_footer_links?colum=column3`,{
            method: 'GET',
            headers : {        
                'Content-Type': 'application/json',
                'Accept': 'application/json', 
            }
        }).then(function (response) {
                return response.json();
        }).then( (result)=> {
            if(result.status === 1){
               setColumn3data(result?.data);
            }
        })
    }


    if(loadFooter){
    return (        
        <>
            {/*<FloatingWhatsApp
                        phoneNumber="+91 8208636201"
                        accountName="JOCOJO Tshirts"
                        allowEsc
                        allowClickAway
                        notification
                        notificationSound
                        avatar={`${process.env.REACT_APP_URL+'/img/jocojo_logo_60.webp'}`}
                      />*/}
            <div className="flex w-full h-6 "></div>
            {/* Top */}
            {hidefooter ?
                null
                :
            <>
            <div className="flex hidden lg:block bg-white ">
            <div className="grid w-full grid-cols-[repeat(auto-fill,minmax(260px,1fr))] gap-6 pt-16 pb-16 md:grid-cols-3 xl:grid-cols-[repeat(auto-fit,minmax(220px,1fr))] xl:gap-8 2xl:gap-2 2xl:grid-cols-4 px-5 md:px-10 lg:px-[50px] xl:px-16 justify-center m-auto">
                <div className="flex flex-col">
                    <h3 className="mt-3 mb-7 text-lg  dark:text-zinc-300">
                    USEFUL LINKS
                    </h3>
                    <ul className="space-y-2">
                        {column1data.map((val,key) => (
                        <li key={`ulink-${nanoid()}`}>
                            {val.link_type == 'relative'?
                                <>{val?.logged_in_only == 1 ?
                                   <>{isLogin && <Link to={`${APP_URL}/${val.url}`} replace={true} className="text-sm text-heading transition-colors hover:text-accent-hover dark:text-zinc-300 dark:hover:text-orange-500"   >{val.title}</Link>}</>
                                    :
                                    <Link to={`${APP_URL}/${val.url}`} replace={true} className="text-sm text-heading transition-colors hover:text-accent-hover dark:text-zinc-300 dark:hover:text-orange-500"   >{val.title}</Link>
                                  }
                                </>
                               :
                               <Link to={`${val.url}`}  replace={true} className="text-sm text-heading transition-colors hover:text-accent-hover dark:text-zinc-300 dark:hover:text-orange-500"   >{val.title}</Link>
                              } 
                        </li>
                     ))
                    }
                    </ul>
                </div>

                <div className="flex flex-col">
                <h3 className="mt-3 mb-7 text-lg  dark:text-zinc-300">
                    GET TO KNOW US
                    </h3>
                    <ul className="space-y-2">
                   
                     {column2data.map((val,key) => (
                        <li key={nanoid()}>
                            {val.link_type == 'relative'?
                                <Link to={`${APP_URL}/${val.url}`} replace={true} className="text-sm text-heading transition-colors hover:text-accent-hover dark:text-zinc-300 dark:hover:text-orange-500"   >{val.title}</Link>
                               :
                               <Link to={`${val.url}`}  replace={true} className="text-sm text-heading transition-colors hover:text-accent-hover dark:text-zinc-300 dark:hover:text-orange-500"   >{val.title}</Link>
                              } 
                        </li>
                     ))
                    }
                    </ul>
                </div>
                <div className="flex flex-col">
                <h3 className="mt-3 mb-7 text-lg dark:text-zinc-300">
                    POLICY
                    </h3>
                    <ul className="space-y-2">
                      
                    {column3data.map((val,key) => (
                        <li key={nanoid()}>
                            {val.link_type == 'relative'?
                                <Link to={`${APP_URL}/${val.url}`} replace={true} className="text-sm text-heading transition-colors hover:text-accent-hover dark:text-zinc-300 dark:hover:text-orange-500"   >{val.title}</Link>
                               :
                               <Link to={`${val.url}`}  replace={true} className="text-sm text-heading transition-colors hover:text-accent-hover dark:text-zinc-300 dark:hover:text-orange-500"   >{val.title}</Link>
                              } 
                        </li>
                     ))
                    }
                    </ul>
                </div>
                <div className="flex flex-col">
                     <h3 className="mt-5 mb-3 text-base font-semibold text-heading dark:text-zinc-300">
                     100% Secure Payment
                    </h3>
                    <div className="flex w-full justify-start items-center">
                    {paymenticons.map((val,key) => {
                       return(<>
                        {key == 0 ?
                        <div  key={nanoid()} className="flex items-center"><LazyLoadImage src={`${BACKEND_URL}/paymenticons/${val.img}`} className="h-12 object-scale-down" alt="payment icons" width={41} height={48} /></div>
                        :
                        <div  key={nanoid()} className="flex items-center ml-2"><LazyLoadImage src={`${BACKEND_URL}/paymenticons/${val.img}`} className="h-12 object-scale-down" alt="payment icons" width={41} height={48} /></div>
                        }
                        </>)
                    })}
                    </div>
                </div>
            </div>
            </div>
            </>
            }
            <div className="px-4 py-4 text-sm">
                <h3 className="text-2xl pb-2">Investment Disclaimer</h3>
                <p>The information provided on this website is for educational and informational purposes only and should not be construed as investment advice, financial advice, trading advice, or any other form of recommendation.</p>
                <p>Investments in securities market are subject to market risks. Please read all related documents carefully before investing.</p>
                <p>This platform does not guarantee the accuracy, completeness, or reliability of any financial data, analysis, projections, or opinions presented. Past performance of securities or financial products is not indicative of future results.</p>
                <p>Users are advised to conduct their own due diligence and consult with a registered financial advisor or investment professional before making any investment decisions.</p>
                <p>The website, its owners, affiliates, and contributors shall not be held responsible for any losses incurred as a result of reliance on the information provided herein.</p>
            </div>
            <div className="hidden lg:block mt-0 lg:mt-8 mb-11 lg:mb-0 flex w-full flex-col  items-center border-t border-gray-200 pt-4 pb-3 lg:mt-0 lg:flex-row lg:justify-between lg:border-t-0 px-5 md:px-10 lg:px-[50px] xl:px-16" style={{backgroundColor:'#18cb96'}}>
                <span className="order-2 text-sm text-white lg:order-1 dark:text-zinc-300">
                &copy; Copyright {new Date().getFullYear()}{' '}
                
                  {FOOTER_SITE} &nbsp;
                
                All rights reserved
                <div className="mt-2">Powered by {ishome && ishome== 'yes' ? <Link
                    className="font-normal  transition-colors hover:text-accent dark:text-zinc-100 dark:hover:text-accent"
                    to='https://sisnolabs.com/'
                    target="_blank"
                     style={{color:'#a0892d'}}
                >
                  SISNOLABS
                </Link>
                :
                <span className="font-normal">SISNOLABS</span> 
                }
                 </div>
                </span>
            </div>    
        
    
        </>
    )
    }else{
        return null
    }

}

export default Footer;